import React from "react";
import { AppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { useCheckin } from "../../../hooks/useCheckin";
import { useContext } from "../../../context";

export function CheckIn() {
  const { isLoading } = useCheckin();

  const {
    modals: { checkin },
  } = useContext();

  return (
    <button
      className="new-green-btn"
      disabled={isLoading}
      onClick={() => checkin.open()}
    >
      <AppTranslation.Common path="label.patient" /> Check In
    </button>
  );
}
